import { Injectable } from '@angular/core';
import { ModalDialogComponent } from '@common/controls/modal-dialog/modal-dialog.component';

@Injectable({ providedIn: 'root' })
export class ModalService {
  public static TimeoutDialogId = 'timeout-dialog';
  public static RefreshApplicationDialogId = 'refresh-application-dialog';
  public static SessionExpiredDialogId = 'session-expired-dialog';
  public static AddAppointmentDialogId = 'add-appointment-dialog';
  public static TakeOverConfirmDialogId = 'take-over-confirm-dialog';
  public static TakeOverWarnDialogId = 'take-over-warn-dialog';
  public static TakeOverFailedDialogId = 'take-over-failed-dialog';
  public static LogOutConfirmDialogId = 'log-out-confirm-dialog';
  public static AgentAdviserFailedDialog = 'agent-adviser-failed-dialog';
  public static AgentIncorrectAvailabilityStatus = 'agent-incorrect-availability-status';

  private modalById = new Map<string, ModalDialogComponent>();

  add(modal: ModalDialogComponent): void {
    this.modalById.set(modal.id, modal);
  }

  remove(id: string): void {
    this.modalById.delete(id);
  }

  open(id: string): void {
    if (this.modalById.has(id)) {
      this.modalById.get(id).open();
    }
  }

  close(id: string): void {
    if (this.modalById.has(id)) {
      this.modalById.get(id).close();
    }
  }

  isOpened(id: string): boolean {
    return this.modalById.has(id) && this.modalById.get(id).isOpened;
  }
}
